export function findLast(array, predicate) {
	if (Array.prototype.findLast) {
		return array.findLast(predicate);
	} else {
		for (let i = array.length - 1; i >= 0; i--) {
			if (predicate(array[i])) {
				return array[i];
			}
		}
	}
}
